'use client';

import * as React from 'react';
import {
    Panel as PanelPrimitive,
    PanelGroup as PanelGroupPrimitive,
    PanelResizeHandle as PanelResizeHandlePrimitive,
    type ImperativePanelHandle,
} from 'react-resizable-panels';
import { cn } from '@/lib/utils';

type PanelGroupProps = React.ComponentProps<typeof PanelGroupPrimitive>;
type PanelProps = React.ComponentProps<typeof PanelPrimitive>;
type PanelResizeHandleProps = React.ComponentProps<typeof PanelResizeHandlePrimitive>;

function PanelGroup({ className, ...props }: PanelGroupProps) {
    return <PanelGroupPrimitive className={cn('h-full w-full', className)} {...props} />;
}

const Panel = React.forwardRef<ImperativePanelHandle, PanelProps>(
    ({ className, ...props }, ref) => (
        <PanelPrimitive ref={ref} className={cn('h-full', className)} {...props} />
    )
);
Panel.displayName = 'Panel';

function PanelResizeHandle({ className, ...props }: PanelResizeHandleProps) {
    return (
        <PanelResizeHandlePrimitive
            className={cn(
                'relative flex items-center justify-center bg-border transition-colors data-[panel-group-direction=horizontal]:w-px data-[panel-group-direction=vertical]:h-px hover:bg-primary/50',
                'after:absolute after:inset-y-0 after:-inset-x-2 after:content-[""]',
                className
            )}
            {...props}
        />
    );
}

export { PanelGroup, Panel, PanelResizeHandle };
